module.exports = __webpack_public_path__ + "img/technique1.77ea79dc.png";